// Fetch wrapper: JSON in and out, files as raw bodies, errors as ApiError with the server's code.
export class ApiError extends Error {
  constructor(
    public readonly code: string,
    public readonly status: number,
    public readonly data: Record<string, unknown> = {},
  ) {
    super(code);
  }
}

export async function api<T = unknown>(method: string, path: string, body?: unknown): Promise<T> {
  const raw = body instanceof Blob;
  let res: Response;
  try {
    res = await fetch(path, {
      method,
      credentials: 'same-origin',
      headers: body === undefined ? {} : { 'Content-Type': raw ? body.type || 'application/octet-stream' : 'application/json' },
      body: body === undefined ? undefined : raw ? body : JSON.stringify(body),
    });
  } catch {
    throw new ApiError('network', 0);
  }
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) throw new ApiError(String(data.error ?? 'server_error'), res.status, data);
  return data as T;
}

export const fileUrl = (token: string, name: string) => `/api/orders/${token}/files/${encodeURIComponent(name)}`;

export const templateFileUrl = (id: string, name: string) => `/api/templates/${id}/files/${encodeURIComponent(name)}`;
export const isVideoFile = (name: string | null | undefined) => !!name && /\.(mp4|webm)$/.test(name);
